import React from 'react';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { SwitchField } from './SwitchField';
import { AddressTaskField } from '../../../../__generated__/AddressTaskField';

type AddressValues = {
  field: AddressTaskField;
};

export const AddressAdditionalField = () => {
  const { values, setFieldValue } = useFormikContext<AddressValues>();
  return (
    <Grid container direction='column' spacing={2}>
      {!values.field.postcodeOnly && (
        <Grid item>
          <SwitchField
            title='Disable manual address entry'
            description='Turn this on to disable the manual entry option for this address field'
            checked={!values.field.allowManual}
            onChange={() => setFieldValue('field.allowManual', !values.field.allowManual)}
          />
        </Grid>
      )}
      <Grid item>
        <SwitchField
          title='Restrict to postcode and state'
          description='Volunteers search for their postcode instead of a full street address'
          checked={values.field.postcodeOnly}
          onChange={() => setFieldValue('field.postcodeOnly', !values.field.postcodeOnly)}
        />
      </Grid>
    </Grid>
  );
};
